<div class="strategy-detail-content" *ngIf="tabsState() as tabsInfo">
  <ng-container *ngTemplateOutlet="titleBar"></ng-container>

  <div class="controller">
    <div class="tabs-container">
      <app-strategy-detail-tabs
        [legComponentsQueryList]="legComponentsQueryList"
        (changeInSelectedTab)="changeInSelectedTab($event)"
      />
    </div>

    <ng-container
      *ngTemplateOutlet="
        controlPanel;
        context: { tabInfo: tabsInfo.tabs[tabsInfo.selectedTab] }
      "
    ></ng-container>
  </div>

  <ng-container
    *ngTemplateOutlet="status; context: { tabsInfo: tabsInfo }"
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="
      legsContainer;
      context: { tabInfo: tabsInfo.tabs[tabsInfo.selectedTab] }
    "
  ></ng-container>
</div>

<app-spot-ladder
  *ngIf="spotLadderOpen"
  [isModalOpened]="spotLadderOpen"
  [legComponents]="legComponents"
  (spotLadderOpenChanged)="onSpotLadderOpenChanged($event)"
>
</app-spot-ladder>

<app-rates-ladder
  *ngIf="ratesLadderOpen"
  [isModalOpened]="ratesLadderOpen"
  [legComponents]="legComponents"
  (openStateChanged)="onRatesLadderOpenChanged($event)"
>
</app-rates-ladder>

<app-spot-spot-matrix
  *ngIf="spotSpotMatrixOpen"
  [isModalOpened]="spotSpotMatrixOpen"
  [legComponents]="legComponents"
  (spotSpotMatrixOpenChanged)="onSpotSpotMatrixChanged($event)"
>
</app-spot-spot-matrix>

<app-save-strategy
  *ngIf="saveStrategyOpen"
  [legs]="legComponents"
  [isModalOpened]="saveStrategyOpen"
  (saveStrategyOpenChanged)="onSaveStrategyOpenChanged($event)"
>
</app-save-strategy>

<app-share-strategy-modal
  *ngIf="shareStrategyOpen"
  [isModalOpened]="shareStrategyOpen"
  (strategyShared)="onStrategyShared($event)"
  (shareStrategyOpenChanged)="onShareStrategyOpenChanged($event)"
>
</app-share-strategy-modal>

<app-delta-by-tenor
  *ngIf="deltaByTenorOpen"
  [isModalOpened]="deltaByTenorOpen"
  [legComponents]="legComponents"
  (deltaByTenorOpenChanged)="onDeltaByTenorChanged($event)"
>
</app-delta-by-tenor>

<app-vega-by-bucket
  *ngIf="vegaByBucketOpen"
  [isModalOpened]="vegaByBucketOpen"
  [legComponents]="legComponents"
  (vegaByBucketOpenChanged)="onVegaByBucketChanged($event)"
>
</app-vega-by-bucket>

<app-multi-leg-solver
  *ngIf="multiLegSolver"
  [legComponents]="legComponents"
  (solverOpenChanged)="showMultiLegSolver($event)"
></app-multi-leg-solver>

@if (payoutGraphOpen) {
  <app-payout-graph
    [isModalOpened]="payoutGraphOpen"
    [legComponents]="legComponents"
    (payoutGraphOpenChanged)="onPayoutGraphChanged($event)"
  >
  </app-payout-graph>
}

<ng-template #titleBar>
  <div class="title-bar">
    Structuring
    <button class="header-button simple-tooltip" data-tooltip="Hide">
      <cds-icon
        shape="shrink"
        class="shrink"
        (click)="hideStructuringPanel()"
      ></cds-icon>
    </button>
  </div>
</ng-template>

<ng-template #controlPanel let-tabInfo="tabInfo">
  <div class="control-panel">
    <div class="control-panel__left">
      <clr-dropdown>
        <button
          class="ui-button ui-button__header primary ui-button--add-leg simple-tooltip"
          type="button"
          [disabled]="!productInfo || !productGroupings"
          clrDropdownTrigger
          data-tooltip="Add leg"
        >
          <cds-icon shape="plus" class="is-solid"></cds-icon>
        </button>
        <clr-dropdown-menu class="level1" clrPosition="top" *clrIfOpen>
          <ng-container *ngIf="productSpecifications && productGroupings">
            <clr-dropdown *ngFor="let productGroup of productGroupings">
              <button clrDropdownTrigger>{{ productGroup.longName }}</button>
              <clr-dropdown-menu>
                <ng-container *ngFor="let product of productGroup.items">
                  <button
                    clrDropdownItem
                    *ngIf="product | legMenuProducts"
                    (click)="addProduct(getProductFromShortName(product))"
                  >
                    {{ (product | legMenuProducts)?.productType.longName }}
                  </button>
                </ng-container>
              </clr-dropdown-menu>
            </clr-dropdown>
          </ng-container>
        </clr-dropdown-menu>
      </clr-dropdown>
      <span class="control-panel__divider"></span>
      <span class="control-panel__market-data">
        <label
          class="control-panel__market-data__label simple-tooltip"
          data-tooltip="Market Data"
          >MD</label
        >

        <button
          class="ui-button ui-button__header live-refresh-button"
          (click)="selectMarketDateLiveOrAuto()"
          [ngClass]="{
            'live-refresh-button--on':
              tabInfo.marketData.marketDataToUse === autoRefreshCode ||
              tabInfo.marketData.marketDataToUse === liveDataCode
          }"
          id="live-refresh-button"
        >
          {{
            tabInfo.marketData.marketDataToUse === liveDataCode
              ? 'Live'
              : 'Auto Refreshing'
          }}
        </button>

        <span class="control-panel__market-data__controls">
          <clr-date-container (click)="freezeDate()">
            <input
              [ngClass]="{
                'market-data__date--freeze-date':
                  tabInfo.marketData.marketDataToUse === pastDateCode &&
                  tabInfo.marketData.frozenTime,
                'market-data__date--date-set': tabInfo.marketData.frozenTime
              }"
              class="market-data__date"
              type="date"
              id="market-data__date"
              clrDate
              placeholder="DD MMM YYYY"
              (blur)="freezeDateBlur($event)"
              (onfocus)="freezeDate()"
              (clrDateChange)="dateChange($event)"
            />
          </clr-date-container>
        </span>
      </span>

      <span class="control-panel__divider"></span>

      <button
        class="ui-button ui-button__header primary"
        (click)="doPriceAll()"
        [disabled]="!canPriceAll()"
        *ngIf="legs.length > 0"
      >
        Price All
      </button>

      <ng-container *ngIf="showRfqButton">
        <a role="tooltip" aria-haspopup="true">
          <button
            [disabled]="rfqDisabled || breakingDownStrategy"
            (click)="createRfq()"
            class="ui-button ui-button__header primary ui-button--rfq simple-tooltip--wide"
            [ngClass]="{ 'simple-tooltip': rfqButtonSettings.rfqErrorMsg }"
            [attr.data-tooltip]="rfqButtonSettings.rfqErrorMsg"
          >
            <ng-container
              *ngIf="!breakingDownStrategy; else notBreakingDownStrategy"
            >
              RFQ
            </ng-container>

            <ng-template #notBreakingDownStrategy>
              <span class="spinner spinner-sm spinner-inverse"> </span>
            </ng-template>
          </button>
        </a>
      </ng-container>

      <button
        class="ui-button ui-button__header ui-button--trades"
        [ngClass]="{
          'ui-button--trades__enabled': tabInfo.tradeViewMode
        }"
        (click)="setTrades(tabInfo.tradeViewMode)"
        *ngIf="showTradeView"
      >
        Trade View
      </button>
    </div>
    <div class="control-panel__right">
      <button
        class="header-button simple-tooltip"
        (click)="legs?.length && openModal('share-strategy')"
        [disabled]="tabInfo.tradeViewMode"
        data-tooltip="Share strategy"
      >
        <img
          src="assets/share.svg"
          [ngClass]="{ 'btn-faded': !legs || legs.length === 0 }"
        />
      </button>
      <button
        class="header-button header-button--save simple-tooltip"
        (click)="legs?.length && openModal('save-strategy')"
        [disabled]="tabInfo.tradeViewMode"
        data-tooltip="Save strategy"
      >
        <img
          src="assets/save-2.svg"
          [ngClass]="{ 'btn-faded': !legs || legs.length === 0 }"
        />
      </button>
      <button
        *ngIf="tabInfo.tradeViewMode && parent.enableInHouseTermSheetService"
        class="header-button simple-tooltip"
        [disabled]="!isAllCheckedLegsValid"
        (click)="requestInHouseTermSheet()"
        data-tooltip="Term Sheet"
      >
        <cds-icon shape="contract"></cds-icon>
      </button>
      <clr-dropdown>
        <button
          class="dropdown-toggle btn-primary main-menu-dropdown ui-button--tool simple-tooltip"
          type="button"
          clrDropdownTrigger
          data-tooltip="Analytical Tools"
        >
          <cds-icon shape="wrench"></cds-icon>
        </button>
        <clr-dropdown-menu class="level1" clrPosition="top" *clrIfOpen>
          <ng-container *ngFor="let tool of analyticalTools">
            <button
              type="button"
              class="btn analytical-tool-btn"
              clrDropdownItem
              (click)="openModal(tool.name)"
              [disabled]="!tool.enabledFn()"
            >
              {{ tool.name }}
            </button>
          </ng-container>
        </clr-dropdown-menu>
      </clr-dropdown>
    </div>
  </div>
</ng-template>

<ng-template #legsContainer let-tabInfo="tabInfo">
  <div
    class="strategy-detail-content__resize-container resize-able scrollable-content"
    appResizerHorizontal
    [minWidth]="750"
  >
    <div class="attributes-legs-container" *ngIf="!isEmpty()">
      <div class="attributes">
        <active-attributes></active-attributes>
        <pricing-results-attributes></pricing-results-attributes>
        <market-data-attributes></market-data-attributes>
        <extra-results-attributes
          *ngIf="activeExtraAttributesLength"
        ></extra-results-attributes>
        <app-dcd-results-attributes
          *ngIf="activeDcdAttributesLength"
        ></app-dcd-results-attributes>
      </div>

      <div
        class="legs"
        [ngClass]="{ empty: isEmpty() }"
        cdkDropList
        [cdkDropListData]="legs"
        [cdkDropListOrientation]="'horizontal'"
        (cdkDropListDropped)="drop($event)"
      >
        <span class="empty-message" *ngIf="isEmpty()"
          >Add leg to start working on a new strategy.</span
        >

        <ng-container *ngIf="legs">
          <ng-container *ngFor="let leg of legs; index as i">
            <app-leg
              [tradingMode]="tabInfo.tradeViewMode"
              [legIndex]="i"
              [leg]="leg"
              [firstLegTradeId]="tabInfo.firstLegTradeId"
              class="leg-container"
              [ngClass]="{ 'leg-container--dim': !leg.checked }"
              [enableSpreadAttributeValue]="checkedLegs.length > 1"
              [firstCheckedLegIndex]="
                checkedLegs.length ? checkedLegs[0].legIndex : null
              "
              [lastCheckedLegIndex]="
                checkedLegs.length
                  ? checkedLegs[checkedLegs.length - 1].legIndex
                  : null
              "
              cdkDrag
              [cdkDragLockAxis]="'x'"
              (changeInLeg)="changeInLegs()"
              (changeInLegPrice)="onLegPricingChanges($event)"
              (changeInCounterParty)="changeInLegCounterParty()"
            >
              <div cdkDragHandle class="btn-dragarea"></div>
            </app-leg>
          </ng-container>
        </ng-container>

        <ng-container>
          <app-sum-leg
            [tabsLegsToAggregate]="tabInfo.legsToAggregate"
            [aggregatedValues]="tabInfo.aggregatedValues"
            [entity]="tabInfo.aggregateLegsEntity"
            [tradeViewMode]="tabInfo.tradeViewMode"
          ></app-sum-leg>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #status let-tabsInfo="tabsInfo">
  <div class="loading-tabs" *ngIf="tabsInfo.tabStatus !== 'ready'">
    <div
      class="loading-tabs__restore-tabs"
      *ngIf="tabsInfo.tabStatus === 'shouldRestore'"
    >
      <span class="loading-tabs__restore-tabs__text">
        Previously saved tabs found. Would you like to restore them?
      </span>
      <span class="loading-tabs__restore-tabs__buttons">
        <button
          class="ui-button ui-button__header primary"
          (click)="restoreLoadedTabs()"
        >
          Yes
        </button>
        <button
          class="ui-button ui-button__header"
          (click)="doNotRestoreTabs()"
        >
          No
        </button>
      </span>
    </div>
  </div>
</ng-template>
